export default __webpack_public_path__ + "static/media/pot3.6cf483a8.svg";